import styles from "./SizeGuide.module.css";

const SIZE_DATA = [
  { mm: 14.9, us: "4",    jp: 7 },
  { mm: 15.3, us: "4½",  jp: 8 },
  { mm: 15.7, us: "5",    jp: 9 },
  { mm: 16.1, us: "5½",  jp: 10 },
  { mm: 16.5, us: "6",    jp: 11 },
  { mm: 16.9, us: "6½",  jp: 13 },
  { mm: 17.3, us: "7",    jp: 14 },
  { mm: 17.7, us: "7½",  jp: 15 },
  { mm: 18.1, us: "8",    jp: 16 },
  { mm: 18.5, us: "8½",  jp: 17 },
  { mm: 19.0, us: "9",    jp: 19 },
  { mm: 19.4, us: "9½",  jp: 20 },
  { mm: 19.8, us: "10",   jp: 21 },
  { mm: 20.2, us: "10½", jp: 22 },
];

export default function SizeGuide() {
  return (
    <div className={styles.page}>
      <div className={styles.hero}>
        <button className={styles.backBtn} onClick={() => window.history.back()}>← Back</button>
        <p className={styles.eyebrow}>Ratnapura Gems</p>
        <h1 className={styles.title}>Ring Size Guide</h1>
        <p className={styles.subtitle}>
          Not sure of your size? Use our guide below to find the perfect fit before placing your order.
        </p>
      </div>

      <div className={styles.content}>

        <div className={styles.methodsGrid}>
          <div className={styles.methodCard}>
            <div className={styles.methodIcon}>💍</div>
            <h3 className={styles.methodTitle}>Measure an Existing Ring</h3>
            <ol className={styles.methodSteps}>
              <li>Find a ring that fits your intended finger comfortably.</li>
              <li>Using a ruler, measure the inner diameter of the ring in millimetres (mm).</li>
              <li>Match that measurement to the table below to find your size.</li>
              <li>If your measurement falls between two sizes, choose the larger size.</li>
            </ol>
            <img src="/ring-size-guide.png" alt="How to measure inner diameter" className={styles.methodImg} />
          </div>

          <div className={styles.methodCard}>
            <div className={styles.methodIcon}>📏</div>
            <h3 className={styles.methodTitle}>Measure Your Finger</h3>
            <ol className={styles.methodSteps}>
              <li>Cut a thin strip of paper or use a piece of string.</li>
              <li>Wrap it around the base of your intended finger snugly but not too tight.</li>
              <li>Mark where the paper or string meets and measure the length in mm.</li>
              <li>Divide that number by 3.14 (π) to get the inner diameter, then find your size below.</li>
            </ol>
            <img src="/finger-measure-guide.png" alt="How to measure your finger" className={styles.methodImgWide} />
          </div>
        </div>

        <div className={styles.tipsBox}>
          <span className={styles.tipIcon}>💡</span>
          <div>
            <p className={styles.tipTitle}>Helpful Tips</p>
            <p className={styles.tipText}>If between sizes, always go larger — a ring that's slightly big can be resized more easily than one that's too small.</p>
          </div>
        </div>

        <div className={styles.tableSection}>
          <h2 className={styles.tableTitle}>Ring Size Conversion Chart</h2>
          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Inner<br/>Diameter(mm)</th>
                  <th>US </th>
                  <th>IND </th>
                </tr>
              </thead>
              <tbody>
                {SIZE_DATA.map((s, i) => (
                  <tr key={i} className={i % 2 === 0 ? styles.rowEven : ""}>
                    <td><strong>{s.mm}</strong></td>
                    <td>{s.us}</td>
                    <td>{s.jp}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className={styles.helpBox}>
          <h3 className={styles.helpTitle}>Still unsure about your size?</h3>
          <p className={styles.helpText}>Our team is happy to guide you. Message us on WhatsApp and we'll help you find the perfect fit.</p>
          <a
            href="https://wa.me/94765851400?text=Hi!%20I%20need%20help%20finding%20my%20ring%20size."
            target="_blank"
            rel="noopener noreferrer"
            className={styles.helpBtn}
          >
            <img src="/whatsapp-logo.png" alt="WhatsApp" width={18} height={18} />
            Ask Us on WhatsApp
          </a>
        </div>

      </div>
    </div>
  );
}